module.exports = __webpack_public_path__ + "static/media/0_2020_06_01.93886efc.jpg";